export const zoomHTMLString = (zoom) => {
  return zoom ?
    ' <span style="color: #606;">data-type</span><span style="color: #660;">=</span>' +
    '<span style="color:#080;">"zoom"</span>' : ''
}
